'use client';

import React from 'react';
import { useAuth } from '@/context/AuthContext';
import OdooAppLauncher from '@/components/OdooAppLauncher';

export default function DashboardPage() {
  const { user } = useAuth();

  const isMasterAdmin = 
    user?.role?.toLowerCase() === 'superadmin' || 
    user?.email?.toLowerCase() === 'regeproptech@gmail.com' ||
    user?.username?.toLowerCase() === 'master_admin';

  return (
    <OdooAppLauncher 
      isOpen={true} 
      isStandalone={true} 
      isMasterAdmin={isMasterAdmin} 
    />
  );
}
